import React from 'react';
import ReactDOM from 'react-dom';

export default function simplePortal(Component, container) {
    return props => {
        if (container) {
            return ReactDOM.createPortal(<Component {...props} />, container);
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./app/javascript/client/components/simplePortal.jsx